import { Input, SimpleChanges } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'profile-picture',
    templateUrl: './profile-picture.component.html',
    styleUrls: ['./profile-picture.component.scss'],
})
export class ProfilePictureComponent implements OnInit {
    @Input() size: number;
    @Input() src: string | SafeUrl | null = null;
    @Input() name: string | null;
    @Input() primaryIdentifier: string | null = null;
    @Input() disable: boolean = false;
    @Input() textSizeRatio: number = 3;
    @Input() pictureChange: boolean = false; // Can be used to manually trigger a picture change (See employee-record-view.component.ts for example)

    constructor() {}

    ngOnInit() {
        // Remove special characters and shorten length to 3 words
        if (this.name) {
            this.name = this.name.replace(/[^a-z0-9]+/gi, ' ');

            let nameParts = this.name.split(' ').splice(0, 3).join(' ');
            this.name = nameParts;
        }
    }
}
